import React, { FC, MouseEvent } from 'react';
import { useTranslation } from '@blocs.i18n';
import { ClearButton } from '../../shared/styles';
import { FilterBasicTogglerContainer, FilterBasicTogglerTitle } from './FilterBasicTogglerStyles';

type Props = {
  isClearButtonVisible: boolean;
  onClear: (filtersKeys?: string[]) => void;
  className?: string;
};

const FilterBasicToggler: FC<Props> = ({ isClearButtonVisible, onClear, className }) => {
  const { t } = useTranslation();

  const handleClear = (event: MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();

    onClear();
  };

  return (
    <FilterBasicTogglerContainer className={className}>
      <FilterBasicTogglerTitle>{t('common:filter.title')}</FilterBasicTogglerTitle>
      {isClearButtonVisible && (
        <ClearButton
          role="button"
          data-qa-id="filter-toggler-clear-button"
          data-testid="filter-toggler-clear-button"
          onClick={handleClear}
        >
          {t('common:button.clear')}
        </ClearButton>
      )}
    </FilterBasicTogglerContainer>
  );
};

export default FilterBasicToggler;
